import { render, staticRenderFns } from "./AccordionCard.vue?vue&type=template&id=c693898e&"
import script from "./AccordionCard.vue?vue&type=script&lang=js&"
export * from "./AccordionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../create-website/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports